<script setup>
import { computed } from 'vue'

const props = defineProps({
  item: { type: Object },
})

const mainGroupingCause = computed(() => {
  if (props.item?.transportBookings?.find(tb => tb.groupingCause == 'manual')) {
    return 'Manual'
  } else if (props.item?.transportBookings?.find(tb => tb.groupingCause == 'manual-milk-run')) {
    return 'Manual merge'
  } else if (props.item?.transportBookings?.find(tb => tb.groupingCause == 'batch_onsite')) {
    return 'Batch onsite request (legacy)'
  } else if (props.item?.transportBookings?.find(tb => tb.groupingCause == 'first_in_group')) {
    return 'Automatic'
  }
  return null
})
</script>

<template lang="pug">
.text-nowrap(v-if="mainGroupingCause?.length") {{ mainGroupingCause }}
</template>
